import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketPriorityInfo } from '../../../../state';
import { useGetTicketPrioritiesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const PriorityEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { data: priorities, isLoading, error } = useGetTicketPrioritiesQuery();

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(updateTicketPriorityInfo({ priority: event.target.value }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Priority</InputLabel>
      <Select
        value={currentTicket?.priorityInfo.priority || ''}
        onChange={handleChange}
        label="Priority"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading priorities...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading priorities</MenuItem>
        ) : (
          priorities?.map((priority) => (
            <MenuItem key={priority.value} value={priority.value}>
              {priority.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default PriorityEdit;
